import { createGlobalStyle } from 'styled-components'
import { AppContext } from '../contexts/AppContext'
import { useIsTablet } from '../hooks/useIsTablet'

const GlobalCSS = createGlobalStyle`
  a,
  a:visited {
    color: inherit;
  }
`

export const AppWrapper = ({ children }: React.PropsWithChildren) => {
  const isTablet = useIsTablet()
  return (
    <>
      <GlobalCSS />
      <AppContext.Provider value={{ isTablet }}>{children}</AppContext.Provider>
    </>
  )
}
